import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useSlackOAuthCallback } from "@/components/integrations/use-slack-oauth-callback";
import { ENV } from "@/constants/env";
import { IntegrationsCard } from "@/pages/settings/components/integrations-card";
import { SentryTest } from "@/pages/settings/components/sentry-test";
import { UserProfileCard } from "@/pages/settings/components/user-profile-card";
import { APP_ROUTES_FULL } from "@/utils/routes";

import { AudioDeviceManagement } from "./components/audio-device-management/audio-device-management";
import { SettingsPanel } from "./components/settings-panel";
import { Route as SettingsRoute } from "./route";

export const Route = createFileRoute(APP_ROUTES_FULL.SETTINGS)({
    component: Settings,
});

function Settings() {
    const { t } = useTranslation();
    const { slack: slackStatus } = SettingsRoute.useSearch();
    const [slackDialogOpen, setSlackDialogOpen] = useState(false);

    useSlackOAuthCallback({
        slackStatus,
        onStatus: () => setSlackDialogOpen(true),
    });

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 auto-rows-auto">
            <div className="flex flex-col bg-background shadow-sm p-4 gap-4 rounded-lg border border-border">
                <SettingsPanel />
            </div>

            <div className="flex flex-col bg-background shadow-sm p-4 gap-4 rounded-lg border border-border">
                <h3 className="text-lg font-semibold">{t("audio_settings")}</h3>
                <AudioDeviceManagement />
            </div>

            <div className="flex flex-col bg-background shadow-sm p-4 gap-4 rounded-lg border border-border">
                <IntegrationsCard slackDialogOpen={slackDialogOpen} onSlackDialogOpenChange={setSlackDialogOpen} />
            </div>

            <div className="flex flex-col bg-background shadow-sm p-4 gap-4 rounded-lg border border-border">
                <UserProfileCard />
            </div>

            {ENV.DEV && (
                <div className="flex flex-col bg-background shadow-sm p-4 gap-4 rounded-lg border border-border md:col-span-2">
                    <SentryTest />
                </div>
            )}
        </div>
    );
}
